import { __decorate, __extends } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import InboundPlanAdd from './index.vue';

var InboundPlanAddPage = function (_super) {
  __extends(InboundPlanAddPage, _super);

  function InboundPlanAddPage() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  InboundPlanAddPage = __decorate([Component({
    components: {
      InboundPlanAdd: InboundPlanAdd
    }
  })], InboundPlanAddPage);
  return InboundPlanAddPage;
}(Vue);

export default InboundPlanAddPage;